import { ApiClient } from './api.ts';

export interface AlertRule {
    id?: string;
    organization_id?: string;
    name: string;
    metric_type: string;
    domain_id: string;
    threshold: number;
    time_window: number;
    enabled: boolean;
    path?: string;
    cooldown_minutes?: number;
    firing?: boolean;
    history?: number[];
    destinations: AlertDestination[];
    created_at?: string;
    updated_at?: string;
}

export interface AlertDestination {
    type: string;
    target: string;
}

export class AlertService {
    private static instance: AlertService;
    private api = ApiClient.getInstance();

    private constructor() { }

    public static getInstance(): AlertService {
        if (!AlertService.instance) {
            AlertService.instance = new AlertService();
        }
        return AlertService.instance;
    }

    public async listByOrganization(orgId: string): Promise<AlertRule[]> {
        return this.api.request<AlertRule[]>(`/organization/${orgId}/alerts`) as Promise<AlertRule[]>;
    }

    public async create(rule: AlertRule, orgId: string): Promise<AlertRule> {
        return this.api.request<AlertRule>(`/alert`, {
            method: 'PUT',
            body: JSON.stringify(rule),
            headers: { 'X-Organization-ID': orgId }
        }) as Promise<AlertRule>;
    }

    public async update(id: string, rule: AlertRule, orgId: string): Promise<AlertRule> {
        return this.api.request<AlertRule>(`/alert/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(rule),
            headers: { 'X-Organization-ID': orgId }
        }) as Promise<AlertRule>;
    }

    public async delete(id: string): Promise<void> {
        await this.api.request<void>(`/alert/${id}`, {
            method: 'DELETE'
        });
    }

    public async get(id: string): Promise<AlertRule> {
        return this.api.request<AlertRule>(`/alert/${id}`) as Promise<AlertRule>;
    }

    public async sendTest(orgId: string, alertId?: string): Promise<void> {
        await this.api.request<void>(`/alert/test`, {
            method: 'POST',
            headers: { 'X-Organization-ID': orgId },
            body: alertId ? JSON.stringify({ alert_id: alertId }) : undefined,
            toast: { success: 'Test alert sent' }
        });
    }
}
